export default "__VITE_ASSET__qX2kKd$n__"